export default __webpack_public_path__ + "static/media/link-gold.288583d9.svg";